var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"uikon",class:{'uikon--close': _vm.icon === 'close'}},[_vm._v(" "+_vm._s((_vm.icon === 'close' ? 'add' : _vm.icon))+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }